module.exports = __webpack_public_path__ + "img/brown-hairy-grass-02.f1aa77bd.png";